import { Payload, payloadSchema } from 'embedded/api/in/messages/Payload';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { JSONSchemaType } from 'ajv';

export interface SetPositionsMessagePayload extends Payload {
    positions: Array<{ symbol: string; side?: 'B' | 'S' | 'SS'; qty?: number }>;
    symbology?: SymbologyValues;
}

export const setPositionsMessagePayloadSchema: JSONSchemaType<SetPositionsMessagePayload> =
    {
        type: 'object',
        properties: {
            ...payloadSchema.properties,
            symbology: {
                type: 'string',
                enum: [
                    SymbologyValues.Instinet,
                    SymbologyValues.Bloomberg,
                    SymbologyValues.CUSIP,
                    SymbologyValues.Local,
                    SymbologyValues.SEDOL,
                ],
                nullable: true,
            },
            positions: {
                type: 'array',
                items: {
                    type: 'object',
                    properties: {
                        symbol: { type: 'string', minLength: 1 },
                        side: { type: 'string', enum: ['B', 'S', 'SS'] },
                        qty: { type: 'number' },
                    },
                    required: ['symbol'],
                },
            },
        },
        required: ['positions'],
        additionalProperties: false,
    };
